import { render, staticRenderFns } from "./VendorTurnover.vue?vue&type=template&id=e3638650"
import script from "./VendorTurnover.vue?vue&type=script&lang=js"
export * from "./VendorTurnover.vue?vue&type=script&lang=js"
import style0 from "./VendorTurnover.vue?vue&type=style&index=0&id=e3638650&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports